import { useRouter } from 'next/router';

import { logger } from '@zep/core-logger';

import { type GetQuizsetRankingsPeriod } from '@/api';

export const useMoveFeaturedPage = (
  schoolType: string,
  period: GetQuizsetRankingsPeriod,
) => {
  const router = useRouter();

  return () => {
    logger.track('featured_more_click', {
      schoolType,
      period,
    });
    void router.push(
      `/quiz/featured?schoolType=${schoolType}&period=${period}`,
    );
  };
};
